<template>
    <div class="person-card">
            <a class="close-button" v-on:click="close">
                <i class="fa fa-times"></i>
            </a>
        <img class="card-image" v-if="attendee.pictureUrl" v-bind:src="attendee.pictureUrl" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'>
        <img class="card-image" v-else src="../assets/icons/anonymous.svg">
        <p class="name">{{attendee.firstName}} {{attendee.lastName}}</p>
        <div class="bottom-content">
            <p class="caption">{{attendee.headline}}</p>
            <p class="caption">{{attendee.location}}</p>
            <div class="social-icons">
                <div class="inline-list" v-for="(network, index) in this.attendee.social" v-bind:key="index"> 
                    <socialIcons v-bind:attendee="attendee" v-bind:network="network"></socialIcons>
                </div>
                    <a v-if="attendee.id !== user.id" v-on:click="openChat(attendee)" class="chat-icon">
                        <img class="dl-logo" src="../assets/icons/person_card_chat_icon.svg">
                    </a>
            </div>
        </div>
    </div>
</template>

<script>

import SocialIcons from '@/components/SocialIcons';
import {EventBus} from '../router/index';

export default {
    components: {
        socialIcons: SocialIcons
    },

    props: {
        attendee: {},
        user: {}
    },

    methods: {
        openChat(person) {
            EventBus.$emit('openChat', person);
        },

        close () {
            this.$emit('cardClosed');
        }
    }
};

</script>

<style lang="scss">

.person-card {
    max-width: 300px;
    max-height: 400px;
    min-height: 300px;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    z-index: 9000;
    margin: 0 auto;
    top: 65px;
    left: 0;
    right: 0;
    padding: 20px 0 0 0;
    background-color: #242424;

    .close-button {
        color: #fff;
        margin: 8px;
        position: absolute;
        top: 15px;
        right: 15px;
        font-size: 20px;
        font-style: normal;
        cursor: pointer;
        font-weight: normal;
        line-height: 1;
        font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .card-image {
        display: block;
        max-width: 100px;
        max-height: 100px;
        height: 100px;
        border-radius: 50%;
        margin: auto;
        border: 7px solid #333;
        background-image: url("../assets/icons/anonymous.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    
    .name {
        margin: 15px auto;
        width: 85%;
        font-size: 19px;
        font-weight: 600;
        line-height: 1.5;
        color: #d4451d;
        text-align: center;
        font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .bottom-content {
        background-color: #fafafa;
        min-height: 70px;
        width: 280px;
        color: #242424;
        padding: 20px 10px 20px 10px;
        display: block;
        font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;

        .caption {
            margin: 10px auto;
            width: 100%;
            text-align: center;
            font-size: 11px;
            line-height: 1.1;
            font-weight: 400;
        }

        .social-icons {
            list-style-type: none;
            padding: 0;
            
            .inline-list {
                display: inline-block;

            }
        }

        .chat-icon {
            float: right;
            cursor: pointer;
            margin-right: 10px;
            margin-top: 20px;

            .dl-logo {
                width: 30px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// PersonCard.vue?399a7620